export const isNumeric = (val) =>{
  return !isNaN(val)
}

export const formatName = (anc) =>{

  return anc.firstName + (' ' + anc.middleName + ' ' || ' ') + (' ' + anc.maidenName + ' ' || ' ') + anc.lastName
}